import logo from './logo.svg';
import './App.css';
import Splash from './pages/Authentication/Splash';
import Login from './pages/Authentication/Login';
import OtpVerification from './pages/Authentication/OtpVerification';
import ProfileSetup from './pages/Authentication/ProfileSetup';
import Home from './pages/Home/Home';
import Explore from './pages/Explore/Explore';
import Search from './pages/Explore/Search';
import MyProfile from './pages/MyProfile/MyProfile';
import EditProfile from './pages/MyProfile/EditProfile';
import AddressBook from './pages/MyProfile/AddressBook';
import Rewards from './pages/MyProfile/Rewards';
import Notification from './pages/Notification/Notification';
import FeedBack from './pages/MyProfile/FeedBack';
import ItemDetails from './pages/Checkout/ItemDetails';
import Checkout from './pages/Checkout/Checkout';
import OrderSuccess from './pages/Checkout/OrderSuccess';
import Tracking from './pages/Checkout/Tracking';
import AuthenticatedRoutes from './routes/AuthenticatedRoutes';
import UnAuthenticatedRoutes from './routes/UnAuthenticatedRoutes';

function App() {
  return (
    // <AuthenticatedRoutes/>
    <UnAuthenticatedRoutes/>
  );
}

export default App;
